import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { currencyFormatter } from 'components/helpers/currency-formatter';
import DataGridCell from './DataGridCell';

export function currencyCell<T>(params: GridRenderCellParams<T>, decimalPlaces = 3) {
  return (
    <DataGridCell
      content={
        params.value !== null
          ? currencyFormatter(params.value, { significantDigits: decimalPlaces })
          : ''
      }
    />
  );
}
